// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".V-2165E794-3AE2-4263-8E40-6A35AF0DFDDF.selected {\n  border: 1px solid green;\n}\n", "",{"version":3,"sources":["webpack://src/formBuilder/structure/elementDecorators/componentSelectDecorator/compact.less"],"names":[],"mappings":"AAGA;EACI,uBAAA;AAFJ","sourcesContent":["#V-0EC7CF29-E8FE-49F1-B837-ED4C4EACC31B{\n\n}\n.V-2165E794-3AE2-4263-8E40-6A35AF0DFDDF.selected{\n    border: 1px solid green;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
